import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

import back from "~/assets/images/arrow.svg";
import Answer2 from "./Contents/2";
import Answer3 from "./Contents/3";
import Answer4 from "./Contents/4";
import Answer5 from "./Contents/5";
import Answer6 from "./Contents/6";

import { Background, Header, BackIcon } from "./styles";

export default function Faq() {
  const [answerId, setAnswerId] = useState();
  const history = useHistory();

  useEffect(() => {
    let params = new URL(document.location).searchParams;
    let id = params.get("id");
    if (id) {
      setAnswerId(id);
    } else {
      window.location.href = "/portal";
    }
  }, [answerId]);

  return (
    <Background>
      <Header>
        <BackIcon>
          <img
            src={back}
            alt="Ícone voltar"
            onClick={() => history.push("/confirmacao-pedido")}
          />
        </BackIcon>
      </Header>
      {answerId === "2" ? <Answer2 /> : null}
      {answerId === "3" ? <Answer3 /> : null}
      {answerId === "4" ? <Answer4 /> : null}
      {answerId === "5" ? <Answer5 /> : null}
      {answerId === "6" ? <Answer6 /> : null}
    </Background>
  );
}
